import Vue from 'vue'
import appService from '../../server/app.service'
import _ from 'lodash'
import router from '../../router'

const state = {
    languages: [],
    language: [],
    id: 0
}

const getters = {
    languages: state => state.languages,
    language: state => state.language,
}

const actions = {

    loadLanguages (context, credentials) {
        appService.connectToServer(credentials).then(data => {
            context.commit('loadLanguages', { languages: data })
        }).catch(error => {
            this.error = error.toString()
            this.dispatch('addMessage', data)
        })
    },

    loadLanguage (context, credentials) {
        appService.connectToServer(credentials).then(data => {
            context.commit('loadLanguage', { language: data })
        }).catch(error => {
            this.error = error.toString()
            this.dispatch('addMessage', data)
        })
    },

    saveLanguage (context, credentials) {
        appService.connectToServer(credentials).then(data => {
            if( data.success ) {
                context.commit('saveLanguageSuccess')
                this.dispatch('addMessage', data)
            } else {
                this.dispatch('addMessage', data)
            }
        }).catch(error => {
            this.error = error.toString()
            this.dispatch('addMessage', data)
        })
    },

    deleteLanguage (context, credentials) {
        appService.connectToServer(credentials).then(data => {
            if( data.success ) {
                context.commit('deleteLanguage', { success: data.success, id: data.id  })
                this.dispatch('addMessage', data)
            } else {
                this.dispatch('addMessage', data)
            }
        }).catch(error => {
            this.error = error.toString()
            this.dispatch('addMessage', data)

        })
    },

    resetLanguage (context) {
        state.language = []
    },

}

const mutations = {

        loadLanguages (state, data) {
            state.languages = data.languages.result
        },
        loadLanguage (state, data) {
            state.language = data.language.result
        },
        saveLanguageSuccess () {
            state.language = []
            router.replace("/languages")
        },
        deleteLanguage (state, data) {
            let index = _.findIndex(state.languages, function(o) { return o.id == data.id; });
            state.languages.splice(index, 1)
        }

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
